export const useGamingBonusMedia = (bonusDetails: Ref<GamingBonusDetail[]>) => {
  const media = ref<Map<string, { id: string; media?: MediaSchema }>>();
  media.value = new Map();

  const { medias: mediasSync, ids } = useMediasSyncGet();

  const refreshMediaMap = (bDetails: GamingBonusDetail[]) => {
    bDetails.forEach((detail) => {
      if (!media.value.get(detail.id)) {
        media.value.set(detail.id, { id: detail.icon, media: null });
      }
    });
  };

  const mediaIds = computed(() => {
    const values = media.value.values();
    return Array.from(values).map((item) => item.id);
  });

  watch(
    () => mediaIds.value,
    async (idsTo) => {
      ids.value = idsTo;
    }
  );

  watch(
    () => mediasSync.value,
    (medias) => {
      const keys = Array.from(media.value.keys());
      keys.forEach((key) => {
        const mediaId = media.value.get(key).id;
        const m = medias.find((m) => m.id === mediaId);
        media.value.get(key).media = m;
      });
    }
  );

  watch(
    () => bonusDetails.value,
    (bDetails) => {
      refreshMediaMap(bDetails);
    }
  );

  return {
    media,
  };
};
